import { combineReducers } from "redux";
import c from "./constant";

function items(state = [], action) {
  switch (action.type) {
    case c.SET_LIABILITIES:
      return action.liabilities;
    case c.CLEAR_LIABILITIES:
      return [];
    default:
      return state;
  }
}

export default combineReducers({ items });
